import type { Ticket, ShiftLite } from "../types";

function toDate(value?: string | null): Date | null {
    if (!value) return null;
    const d = new Date(value);
    return Number.isNaN(d.getTime()) ? null : d;
}

export function canAssignTicketToShift(ticket: Ticket, shift: ShiftLite): boolean {
    const ticketStart = toDate(ticket.ticketTimeStart);
    const ticketEnd = toDate(ticket.ticketTimeEnd);
    const shiftStart = toDate(shift.start);
    const shiftEnd = toDate(shift.end);

    if (!ticketStart || !ticketEnd || !shiftStart || !shiftEnd) return false;

    // ticket skal v�re fuldt d�kket af vagten
    return ticketStart >= shiftStart && ticketEnd <= shiftEnd;
}

export function getShiftTicketMismatchReason(ticket: Ticket, shift: ShiftLite): string | null {
    const ticketStart = toDate(ticket.ticketTimeStart);
    const ticketEnd = toDate(ticket.ticketTimeEnd);
    const shiftStart = toDate(shift.start);
    const shiftEnd = toDate(shift.end);

    if (!ticketStart || !ticketEnd || !shiftStart || !shiftEnd) {
        return "Manglende dato/tid p� ticket eller vagt";
    }

    if (ticketStart < shiftStart || ticketEnd > shiftEnd) {
        return "Ticketens tidsrum ligger uden for vagtens tidsrum";
    }

    return null;
}